import { useState, useRef, useEffect } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import classes from "./formDropdown.module.css";

export const FormDropdown = ({
  id,
  label,
  options = [],
  register,
  setValue,
  watch,
  disabled = false,
  validation = {},
  error,
  required = false,
  value: standaloneValue,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Determine value: RHF mode or standalone mode
  const value = watch ? watch(id) : standaloneValue;

  useEffect(() => {
    const handler = (e) => {
      if (!dropdownRef.current?.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);

  const handleSelect = (option) => {
    if (disabled) return;

    if (watch && setValue) {
      setValue(id, option.id, { shouldValidate: true });
    } else if (onChange) {
      onChange(option.id);
    }
    setOpen(false);
  };

  // Container and label state
  const containerState = error ? classes.error : value ? classes.selected : "";
  const labelState = error
    ? classes.labelError
    : value
    ? classes.labelActive
    : "";

  return (
    <div className={classes.wrapper} ref={dropdownRef}>
      <div
        className={`${classes.dropdownBox} ${containerState} ${
          disabled ? classes.disabled : ""
        }`}
        onClick={() => !disabled && setOpen((p) => !p)}
      >
        {/* Hidden input for RHF */}
        {register && <input type="hidden" {...register(id, validation)} />}

        <div className={classes.displayText}>
          {value ? options.find((o) => o.id === value)?.label : ""}
        </div>

        <label className={`${classes.floatingLabel} ${labelState}`}>
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </label>

        <span className={classes.arrow}>{open ? "▲" : "▼"}</span>

        {error && typeof error === "string" && (
          <div className={classes.errorIcon} title={error}>
            <ExclamationCircleIcon className={classes.icon} />
          </div>
        )}
      </div>

      {open && !disabled && (
        <ul className={classes.optionsList}>
          {options.map((option) => (
            <li
              key={option.id}
              className={`${classes.option} ${
                option.id === value ? classes.selectedOption : ""
              }`}
              onClick={() => handleSelect(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
